import { ExtendCSS, Flex, Text, ThemePicker } from 'vcc-ui';

import { ThemeVariant } from '@collab/style/customThemeTokens';

import colors from 'styles/colors';

import blockStyle, { baseBlockStyle } from './ColorBlock.styles';

export type ColorBlockProps = {
  color: string;
  label?: string;
  darkText?: boolean;
  hasBorder?: boolean;
  variant?: 'large' | 'small';
  extend?: ExtendCSS;
};

export type ColorBlockStandaloneProps = Omit<ColorBlockProps, 'variant'> & {
  themeVariant?: ThemeVariant;
};

const ColorBlock: React.FC<ColorBlockProps> = ({
  color,
  label,
  darkText = false,
  hasBorder = false,
  variant = 'small',
  extend,
}) => {
  const variantStyle = blockStyle[variant];
  let currentColor = color;
  let currentLabel = label;
  const isCustomDarkColor = color.match(/^dark\./);

  if (isCustomDarkColor) {
    currentColor = getCustomColorFromObjectString(color);
    currentLabel = 'HEX ' + currentColor;
  }

  return (
    <Flex
      extend={[baseBlockStyle(currentColor, hasBorder), variantStyle, extend]}
    >
      {label && <BlockLabel label={currentLabel || ''} darkText={darkText} />}
    </Flex>
  );
};

export const ColorBlockStandalone: React.FC<ColorBlockStandaloneProps> = ({
  themeVariant = 'light',
  ...props
}) => (
  <ThemePicker variant={themeVariant}>
    <ColorBlock {...props} variant="large" />
  </ThemePicker>
);

const BlockLabel: React.FC<{
  label: string;
  darkText?: boolean;
}> = ({ label, darkText }) => (
  <Text
    extend={({ theme: { color } }) => ({
      textTransform: 'uppercase',
      color: darkText ? color.primitive.black : color.primitive.white,
    })}
  >
    {label}
  </Text>
);

const getCustomColorFromObjectString = (color: string) => {
  const splitColor = color.split('.');

  return splitColor.reduce((colorValues: any, prop: string) => {
    return colorValues && colorValues[prop];
  }, colors);
};

export default ColorBlock;
